import request from '@/utils/request'
// import qs from 'qs'

// 时间轴
export const pageList = (getData) => {
  return request({
    url: '/back/official-website-text-editor/timeAxis',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}

// 删除
export const deleteList = (getData) => {
  return request({
    url: '/back/official-website-text-editor/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateList = (postData) => {
  return request({
    url: '/back/official-website-text-editor/updateById',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addList = (postData) => {
  return request({
    url: '/back/official-website-text-editor/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
